/**
 * Sticky Navbar Module
 * File: sticky-navbar.js
 * Description: Questo modulo gestisce la logica della sticky navbar, attivandola solo quando raggiunge il top della finestra.
 * Usato sul menu principale (#mainNavbarWrapper): la top bar con i loghi scorre via,
 * la barra del menu resta fissa in alto.
 *
 */

const StickyNavbar = {
  navbar: null,
  adminBar: null,
  navbarHeight: 0,
  isSticky: false,
  triggerOffsetTop: 0,

  // Inizializza la navbar sticky con ID dinamico e opzionale adminBar
  initialize(navbarId = "mainNavbarWrapper", adminBarId = "wpadminbar") {
    this.navbar = document.getElementById(navbarId);
    this.adminBar = adminBarId ? document.getElementById(adminBarId) : null;

    if (!this.navbar) {
      return;
    }

    this.measure();
    this.attachScrollListener();
    this.attachResizeListener();
    this.handleScroll();
  },

  // Altezza della admin bar solo quando è fissa (sotto i 600px WP la rende absolute)
  getAdminBarOffset() {
    if (!this.adminBar || window.getComputedStyle(this.adminBar).position !== "fixed") {
      return 0;
    }

    return this.adminBar.offsetHeight;
  },

  // Calcola altezza della navbar e distanza dal top del documento (navbar non sticky)
  measure() {
    this.navbarHeight = this.navbar.offsetHeight;
    this.triggerOffsetTop =
      this.navbar.getBoundingClientRect().top + window.scrollY;
  },

  // Aggiorna il padding-top del body SOLO quando la navbar diventa sticky
  updateBodyPadding(applyPadding) {
    document.body.style.paddingTop = applyPadding ? `${this.navbarHeight}px` : "";
  },

  // Imposta la posizione top della navbar in base all'admin bar
  adjustNavbarPosition(applyOffset) {
    this.navbar.style.top = applyOffset ? `${this.getAdminBarOffset()}px` : "";
  },

  setSticky(sticky) {
    this.navbar.classList.toggle("sticky-navbar", sticky);
    this.adjustNavbarPosition(sticky);
    this.updateBodyPadding(sticky);
    this.isSticky = sticky;
  },

  // Aggiunge o rimuove la classe sticky in base allo scroll
  handleScroll() {
    const shouldStick =
      window.scrollY >= this.triggerOffsetTop - this.getAdminBarOffset();

    if (shouldStick !== this.isSticky) {
      this.setSticky(shouldStick);
    }
  },

  // Listener per lo scroll
  attachScrollListener() {
    window.addEventListener("scroll", () => this.handleScroll(), { passive: true });
  },

  // Listener per il resize: rimisura con la navbar nel flusso, poi riapplica lo stato
  attachResizeListener() {
    window.addEventListener("resize", () => {
      if (this.isSticky) {
        this.setSticky(false);
      }

      this.measure();
      this.handleScroll();
    });
  },
};

export default StickyNavbar;
